import React from 'react';

const SentArrow = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='19'
      height='13'
      viewBox='0 0 19 13'
      fill='none'
      {...props}
    >
      <path
        d='M0.5 6.5L6.5 0.5M0.5 6.5L6.5 12.5M0.5 6.5H12.5C14.5 6.5 18.5 7.7 18.5 12.5'
        stroke='black'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export default SentArrow;
